export default {
  withdrawConfig: { method: 'get', url: '/api/v1/withdraw/withdrawConfig', config: { requiresToken: true } }, // 提现配置
  doWithdraw: { method: 'post', url: '/api/v1/withdraw/apply', config: { requiresToken: true } }, // 提现
  withdrawList: { method: 'get', url: '/api/v1/withdraw/list', config: { requiresToken: true } }, // 提现记录
  getIncomeLog: { method: 'get', url: '/api/v1/user/incomeList', config: { requiresToken: true } }, // 资金记录
  getIncomeCalendar: { method: 'get', url: '/api/v1/user/incomeCalendar', config: { requiresToken: true } } // USDT 静态收益日历
}
